import { z } from 'zod'

export const personDisplaySchema = z.object({
  name: z.string().nullish(),
  firstName: z.string().nullish(),
  lastName: z.string().nullish(),
  profileImage: z.string().nullish(),
})
